<div class="columns-select">
  <div class="columns-select-input" [matMenuTriggerFor]="menu">
    <img src="assets/images/common/settings.svg" class="button-icon" alt="column selection" />
    <div class="filter-text">COLUMNS</div>
  </div>
  <mat-menu #menu class="columns-select-options">
    <div class="columns-select-options-reset-all" (click)="selectAll()">Select All</div>
    <div
      class="columns-select-options-container"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      (click)="$event.stopPropagation()"
    >
      @for (column of columns(); track column.propertyKey) {
        <div class="columns-select-option" [ngClass]="{ 'columns-select-option-selected': column.hidden }" cdkDrag>
          <img class="icon" src="assets/images/common/grip-horizontal.svg" alt="reorder" />
          <mat-checkbox
            color="primary"
            [checked]="!column.hidden"
            [disabled]="visibleColumnsIds().length === 1 && visibleColumnsIds()[0] === column.propertyKey"
            (change)="onSelect(column)"
          />
          <div class="columns-select-option-text" appLongTextTooltip>
            {{ column.labelPath | labelsProvider }}
          </div>
        </div>
      }
    </div>
  </mat-menu>
</div>
